const ensureArray = (value) => Array.isArray(value) ? value : [value];

export { ensureArray };
//# sourceMappingURL=ensureArray.es.js.map
